module.exports = __webpack_public_path__ + "static/media/2015.7dcc4cdb.jpg";